import { render, staticRenderFns } from "./NovoBemDigitalizado.vue?vue&type=template&id=a4d2a63c"
import script from "./NovoBemDigitalizado.vue?vue&type=script&lang=js"
export * from "./NovoBemDigitalizado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports